mtl.alloy.factory['paginate-products'] = (function($) {
    'use strict';

    var $replaceState = false;

    var $productImportRequest = false;

    return function(element, options) {

        initialiseForm(element);

        $( ".range").each(function(){
            var $rangeContainer = $(this).closest('.range-container');
            var $minObj = $( ".min", $rangeContainer);
            var $maxObj = $( ".max", $rangeContainer);
            var $min = $minObj.val();
            var $max = $maxObj.val();

            $rangeContainer.siblings('.reset').on('click', function(){
                $minObj.val('');
                $maxObj.val('');

                $(this).closest('form').submit();
            });

            if($min == '')
                $min = Math.floor($rangeContainer.data('min'));

            if($max == '')
                $max = Math.ceil($rangeContainer.data('max'));

            $(this).slider({
                range: true,
                min: parseInt($min),
                max: parseInt($max),
                values: [$min, $max],
                slide: function( event, ui ) {
                    var $container = $(this).closest('.range-container');
                    if($( ".amount", $container ).hasClass('price'))
                    {
                        $( ".amount", $container ).text( currencyFormat(ui.values[ 0 ]) + " - " + currencyFormat(ui.values[ 1 ]));
                    } else {
                        $( ".amount", $container ).text( ui.values[ 0 ] + "mm - " + ui.values[ 1 ] + "mm" );
                    }
                },
                stop: function( event, ui ) {
                    var $container = $(this).closest('.range-container');
                    $( ".min", $container ).val( ui.values[ 0 ] );
                    $( ".max", $container ).val( ui.values[ 1 ] );

                    $(this).closest('form').submit();
                }
            });

            if($( ".amount", $rangeContainer ).hasClass('price'))
            {
                $( ".amount", $rangeContainer).text( currencyFormat($('.range', $rangeContainer).slider( "values", 0 )) + " - " + currencyFormat($('.range', $rangeContainer).slider( "values", 1 )) );
            } else {
                $( ".amount", $rangeContainer).text( $('.range', $rangeContainer).slider( "values", 0 ) + "mm - " + $('.range', $rangeContainer).slider( "values", 1 ) + "mm" );
            }
        });

        if($(element).is('form'))
        {
            $(window).unbind("popstate").on("popstate", function(e) {
                $('input, select', element).unbind('change');

                var state = e.originalEvent.state;
                var $filter = $('.filter');
                $('input', $filter).prop('checked', false);

                $replaceState = true;

                if (state !== null) {
                    
                    if (state.path !== null) {
                        var $urlParams = $.deparam(state.path);

                        var $f = ($urlParams.hasOwnProperty('f')) ? $urlParams.f : '';

                        var $tags = $f.split('/');

                        $($tags).each(function( index, value ){
                            $('input[data-lookup="'+value+'"]', $filter).prop('checked', true);
                        });

                        var $rangeArray = $urlParams.range;

                        $(".range").each(function(){
                            var $rangeContainer = $(this).closest('.range-container');
                            $(this).slider('option',{ min: parseInt($rangeContainer.data('min')), max: parseInt($rangeContainer.data('max')) });
                        });

                        $.each($rangeArray, function( key, range ){
                            $(".min."+key).val(range.min);
                            $(".max."+key).val(range.max);
                            $(".range."+key).slider('option',{min: parseInt(range.min), max: parseInt(range.max)});
                        });
                    }
                }

                initialiseForm(element);

                $(element).submit();
            });
        }
    };

    function initialiseForm(element)
    {
        if($(element).is('form'))
        {
            $('input, select', element).unbind('change').on('change', function(){
                $(this).closest('form').submit();
            });
            $(element).unbind('submit').on('submit', loadProducts);
        } else {
            $(element).unbind('click').on('click', loadProducts);
        }
    }

    function loadProducts(e)
    {
        e.preventDefault();

        var $target = $(e.target);
        var $signposts = $('.category-container .signposts');
        var $pagination = $('.seo-pagination');
        var $filter = $('.filter');
        var $range = $('input[name^="range"]');
        var $sortby = $('.category-sort');
        var $categoryTitle = $('.category-title');
        var $data = new Object();
        var $replace = true;

        $filter.addClass('loading');

        //Don't replace all of the content if the target is not a form
        if(!$target.is('form'))
        {
            var $currentCount = $('.signpost:not(.empty)', $signposts).length;
            $data.offset = $currentCount;
            $replace = false;
        }

        //Add sortby filter to the URL
        if($('#sortby', $sortby).length > 0)
        {
            $data.sortby = $('#sortby', $sortby).val();

            if($data.sortby === '- Select -')
                delete $data.sortby;
        }

        if($('input[name="s"]', $filter).val() !== '')
            $data.s = $('input[name="s"]', $filter).val();

        var $url = $target.attr('data-url') || $target.attr('action');

        if(typeof $url === "undefined" || $url === '')
            $url = window.location.pathname;

        //Create filter query string from URL
        var $filterString = [];
        $('input[type="checkbox"]', $filter).each(function(){
            if($(this).prop('checked'))
            {
                $filterString.push($(this).data('lookup'));
            }
        });

        // if($filterString.length == 0)
        // {
        //     $('.category-description').slideDown();
        // } else {
        //     $('.category-description').slideUp();
        // }
        
        //Remove unset values from the ranges object
        $range.each(function(index, value){
            if($(this).val() == '')
                delete $range[index];
        });
        $range = $.grep($range,function(n){ return n == 0 || n });

        var newurl = window.location.protocol + "//" + window.location.host + $url + '?f=' + $filterString.join('/') + ((!$.isEmptyObject($data)) ? '&' + $.param($data) : '') + ((!$.isEmptyObject($range)) ? '&' + decodeURIComponent($.param($range)) : '');

        if($productImportRequest)
            $productImportRequest.abort();

        $productImportRequest = $.ajax({
            url: newurl,
            cache: false,
            success: function(htmlContent){
                var $newContent = $(htmlContent);
                var redirect = $newContent.filter('[data-canonical]').attr('data-canonical');
                var canonical = newurl;

                if (redirect !== undefined) {
                    canonical = window.location.protocol + "//" + window.location.host + '/' + redirect + '.html';
                }

                if($replace)
                {
                    $signposts.hide().html($('.signpost', htmlContent)).fadeIn();
                } else {
                    $signposts.append($('.signpost', htmlContent)).hide().fadeIn();
                }

                $pagination.hide().html($('.seo-pagination__link', htmlContent).parent()).fadeIn();

                var scrollTop = $(window).scrollTop(); // this stops Chrome scrolling to the bottom of the added content. No idea why!

                $('.flashes').remove();

                $sortby.replaceWith($newContent.filter('.category-sort')/*.hide().fadeIn()*/);
                $filter.replaceWith($newContent.filter('.filter')/*.hide().fadeIn()*/);

                var $categoryTitleContent = $newContent.filter('.category-title');
                if($categoryTitleContent.text() !== ''){
                    $categoryTitle.replaceWith($categoryTitleContent);
                    $('title').html($categoryTitleContent.html());
                }

                var $categoryDescriptionContent = $newContent.filter('.category-description');
                $('.category-description').replaceWith($categoryDescriptionContent);

                $filter.removeClass('loading');

                //Change the URL in the history
                if (history.pushState && !$replaceState)
                {
                    window.history.pushState({path:canonical},'',canonical);
                } else {
                    window.history.replaceState({path:canonical},'',canonical);
                }

                //Replace state condition
                $replaceState = false;

                mtl.alloy.process(document.body);
            },
            error: function(jqXHR,textStatus,errorThrown){
                if(errorThrown != 'abort')
                    location.reload();
            }
        });
    }

}(jQuery));
